import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import otterize from '../assets/imgs/otterize/otterize-cube-logo-img.png'; 
import arrows from '../assets/imgs/arrows/cover-img.png'; 
import navina from '../assets/imgs/navina/navina00.png'; 
import navina_quality from '../assets/imgs/navina/navina _quality _video _cover.png'; 
import navina2024 from '../assets/imgs/navina/navina-videos-cover-img.png'; 
import vayyar from '../assets/imgs/vayyar/cover-img.png'; 
import geoxITC from '../assets/imgs/geoxITC/cover-img.jpg'; 


const categories = ['Everything', '2D', '3D', 'Explainer Video', 'Brandng', 'Development', 'VR/AR', 'UX/UI', 'Booths', 'Websites',];

const works = [
  {
    title: "Presenting Navina's Quality Tools",
    image: navina_quality,
    link: "/navina-risk",
    categories: ['Everything', 'Explainer Video', 'Brandng', '2D']
  },
  {
    title: "Navina: AI-powered risk adjustment",
    image: navina2024,
    link: "/navina-risk",
    categories: ['Everything', 'Explainer Video', 'Brandng', '2D']
  },
  {
    title: "geox ITC 24",
    image: geoxITC,
    link: "/geoxITC",
    categories: ['Everything', 'Explainer Video', 'Brandng', 'Booths', '3D']
  },
  {
    title: "Navina web animations",
    image: navina,
    link: "/navina2024",
    categories: ['Everything', 'Websites', 'UX/UI', '2D', 'Brandng']
  },
  {
    title: "Easier app with animated installtion guide",
    image: vayyar,
    link: "/vayyar",
    categories: ['Everything', 'Development', '2D']
  },
  {
    title: "Otterise explainer video",
    image: otterize,
    link: "/otterize",
    categories: ['Everything', 'Explainer Video', 'Branding', '2D']
  },
  {
    title: "Arrows: empowering social skills",
    image: arrows,
    link: "/arrows",
    categories: ['Everything', '3D', 'Explainer Video', 'Development']
  },




];



const WorksPage = ({}) => {

  const [selectedCategory, setSelectedCategory] = useState('Everything');

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  const filteredWorks = selectedCategory === 'Everything'
    ? works
    : works.filter(work => work.categories.includes(selectedCategory));


  return (
    <div className='bg-light px-3 px-sm-5'>
      <div className='header-height'></div>

      <div className='row my-5 py-5'>
        <div className='col-md-8 col-sm-12'>
          <div className='row row-cols-2 row-cols-sm-4 py-2'>
            {categories.map((category) => (
              <button
                key={category}
                className={`btn btn-category btn-outline-light text-dark text-start text-capitalize fw-light ${selectedCategory === category ? 'active' : ''}`}
                onClick={() => handleCategoryClick(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className='row'>
      {filteredWorks.map((work) => (
          <div key={work.title} className='col-md-6 col-sm-6 col-xs-12 pb-3 pointer mb-5 '>
            <Link to={work.link}>
              <div className='image-container-h-350px'>
                <img className='img-fluid img-square' src={work.image} alt={work.title} />
              </div>
              <div className='my-2 text-dark'>
                <h6 className='fs-18 fw-normal text-capitalize'>{work.title}</h6>
              </div>
            </Link>
          </div>
        ))}

        <div className='row h-60 p-5 mb-5 align-items-center'>
          <div className='col-12 px-5 mx-auto'>
            <h3 className='fw-normal lh-sm text-center'>
              Let's co-create something great for your brand
            </h3>
            <div className='mt-4 text-center'>
              <Link to="/contact">
                <button className='btn btn-primary rounded-3 fw-bold px-3'>Let's Talk</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorksPage;
